import {logger} from '#logger';

export const resolveCalltechParentOrigin = ({
    allowedOrigins,
    ancestorOrigin,
    referrer,
}: {
    allowedOrigins: string[];
    ancestorOrigin?: string;
    referrer: string;
}) => {
    try {
        const parentOrigin = new URL(ancestorOrigin || referrer).origin;

        return allowedOrigins.includes(parentOrigin) ? parentOrigin : null;
    } catch (error) {
        logger.error(
            {message: 'Invalid Calltech parent origin'},
            error,
        );

        return null;
    }
};
